import useFormContext from "./useFormEventMltComplete";
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import * as L from 'leaflet';
import { SITES_BASE_URL } from "../ApiDetails.js";
import { OpenStreetMapProvider } from 'leaflet-geosearch';

const EventMlt = () => {
  const { eventFormData, setEventFormData, handleChange, errors, fetchEventTypes,
    fetchEventFormat, fetchLastVisit, fetchAssociateAtEvent, fetchCountry, fetchPhonecode,
    eventTypeList, eventFormatList, lastVisitList, phoneCodeList, nonEditable,
    handleNonEditableUI, fetchUsers, suggestion, selectSuggestionValue,
    toggleAssociatesCheckbox, associateAtEventChecked,
    checkBoxSelected, fetchSiteCodes, siteCodelist, handleEmailValidation,
    searchAddress, setSearchAddress,
    isEventOffSite, setIsEventOffSite
  } = useFormContext();

  const [mapMarker, setMapMarker] = useState(null);
  const leafLetMap = useRef(null);
  const [timer, setTimer] = useState(null);

  if (nonEditable) {
    handleNonEditableUI()
  }

  const isFirstRender = useRef(true);
  const storedRole = localStorage.getItem('role');

  useEffect(() => {
    if (isFirstRender.current) {
      var u = window.location.href.split("/")[3];
      if (u !== "getDetail") {
        fetchAssociateAtEvent();
        if (isFirstRender.current) {
          loadInitMap();
        }
        isFirstRender.current = false;
      }

      fetchEventTypes();
      fetchEventFormat();
      fetchLastVisit();
      fetchUsers();
      fetchSiteCodes();
      fetchCountry();
      fetchPhonecode();
    }

    if (checkBoxSelected) {
      associateAtEventChecked.forEach((element) => {
        if (element.checked)
          document.getElementById(element.value).checked = true;
      });
    }
    var asso = eventFormData.associates;
    var assoList = asso.split(",");
    associateAtEventChecked.forEach((element) => {
      assoList.forEach((ass) => {
        if (ass.trim() == element.value.trim()) {
          element.checked = true;
          document.getElementById(element.value).checked = true;
        }
      });
    });

  }, [eventFormData, associateAtEventChecked]);

  const associateMapping = {
    "Corporate": "marsCorporateAttendees",
    "Food & Nutrition & Multisales": "marsFoodNutritionAttendees",
    "Mars Global Services": "marsGlobalServicesAttendees",
    "Multisales": "marsMultisalesAttendees",
    "Snacking": "marsSnackingAttendees",
    "Petcare": "marPetCareAttendees",
    "Veterinary Health": "marsVeterinaryHealthAttendees",
  };
  // Empty dependency array to run only once on component mount

  useEffect(() => {
    if (eventFormData.siteCode) {
      setIsEventOffSite(eventFormData.siteCode === "OFF");
      if (eventFormData.siteCode === "OFF")
        fetchAddressCoordinates(eventFormData.eventAddress);
      else
        fetchCityCoordinates(eventFormData.siteCode);
    }
  }, [eventFormData.siteCode]);

  const loadInitMap = async () => {
    if (!leafLetMap.current) {
      leafLetMap.current = L.map(document.getElementById("MapID"));
      leafLetMap.current.invalidateSize();
    }

    L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

  }

  const fetchCityCoordinates = async (siteCode) => {
    try {

      const response = await axios.get(`${SITES_BASE_URL}/${siteCode}`);

      // Check if the response contains valid data
      if (response.data) {
        const { latitude, longitude, unit, location, address, country, city } = response.data;

        if (!leafLetMap.current) {
          leafLetMap.current = L.map(document.getElementById("MapID"));
          leafLetMap.current.invalidateSize();
        }

        leafLetMap.current.setView([latitude, longitude], 14);
        L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

        L.Icon.Default.mergeOptions({
          iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
          iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
          shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        });

        if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
        setMapMarker(null);
        var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
        setMapMarker(marker);

        setEventFormData(prevData => ({
          ...prevData,
          eventVenueName: unit ?? prevData.eventVenueName,
          eventAddress: address ?? prevData.eventAddress,
          countryName: country ?? prevData.countryName,
          stateName: location ?? prevData.stateName,
          cityName: city ?? prevData.cityName,
          mltEvent: storedRole === "MLTUser" ? true : eventFormData.mltEvent
        }));
      } else {
        console.error("No data found for the specified site code.");
      }
    } catch (error) {
      console.error("Error fetching site coordinates:", error);
    }
  };

  const fetchAddressCoordinates = async (address) => {
    const provider = new OpenStreetMapProvider();
    const results = await provider.search({ query: address });
    if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
    setMapMarker(null);
    if (!results[0]) {
      leafLetMap.current.setView([0, 0], 14);
      return;
    }
    const latitude = results[0].y;
    const longitude = results[0].x;

    if (!leafLetMap.current) {
      leafLetMap.current = L.map(document.getElementById("MapID"));
      leafLetMap.current.invalidateSize();
    }

    leafLetMap.current.setView([latitude, longitude], 14);
    L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
      iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    });

    var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
    setMapMarker(marker);
  };

  const rebuildCurrentSiteAddress = () => {
    var address = eventFormData.eventAddress;
    address = address.replace("\n", " ");
    if (eventFormData.eventVenueName) address = eventFormData.eventVenueName + ", " + address;
    if (eventFormData.cityName) address = address + ", " + eventFormData.cityName;
    if (eventFormData.stateName) address = address + ", " + eventFormData.stateName;
    if (eventFormData.countryName) address = address + ", " + eventFormData.countryName;
    return address;
  };

  const handleSearchAddressChange = async (e) => {
    var address = e.target.value;
    setSearchAddress(e.target.value);
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        setSearchAddress(address);
        fetchAddressCoordinates(address);
      }, 500)
    );
  }

  const handleOffSiteChange = async (e) => {
    setIsEventOffSite(e.target.checked);
    if (e.target.checked) {
      var address = searchAddress;
      if (address === "") {
        address = rebuildCurrentSiteAddress();
        setSearchAddress(address);
      }
      fetchAddressCoordinates(address);
    }
    else {
      fetchCityCoordinates(eventFormData.siteCode);
    }
  };

  const handleSiteChange = (e) => {
    handleChange(e);
    fetchCityCoordinates(e.target.value);
  };

  const content = (
    <>
      <div className="col-md-6">
        <div className=" bg-light rounded p-3 ">
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              REQUESTED BY
            </label>
            <div className="col-sm-8 ">

              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control-plaintext disabled"
                id="requestedBy"
                name="requestedBy"
                value={eventFormData.requestedBy}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
                placeholder={nonEditable ? "" : "name"}
                autoComplete="off"
              />
              {
                suggestion?.length > 0 ? (
                  <div className='suggestion-wrapper'>
                    {
                      suggestion.map(item => {
                        return (
                          <div className='custom-font-lt form-control-plaintext suggestions' key={item} onClick={() => selectSuggestionValue(item)}>
                            {item}
                          </div>
                        )
                      })
                    }
                  </div>
                ) : null
              }
              {errors.requestedBy && <div style={{ color: 'red', fontSize: "13px" }}>{errors.requestedBy}</div>}

            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT TITLE
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control"
                id="staticEmail"
                name="eventTitle"
                value={eventFormData.eventTitle}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
                placeholder={nonEditable ? "" : "Title"}
              />
              {errors.eventTitle && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventTitle}</div>}
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              ASSOCIATE&apos;S SEGMENT
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control disabled"
                id="staticEmail"
                name="associateSegment"
                value={eventFormData.associateSegment}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
              />
              {errors.associateSegment && <div style={{ color: 'red', fontSize: "13px" }}>{errors.associateSegment}</div>}
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label disabled"
            >
              E-MAIL
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                readOnly=""
                className="custom-font-lt form-control"
                id="email"
                name="email"
                value={eventFormData.email}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
              />
              {errors.email && <div style={{ color: 'red', fontSize: "13px" }}>{errors.email}</div>}
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              PHONE
            </label>
            <div className="col-sm-8 ">
              <div className="row">
                <div className="col-4">
                  <select
                    className="custom-font-lt form-control form-select form-select-sm"
                    aria-label="Small select example"
                    id="staticPhone"
                    name="phoneCode"
                    value={eventFormData.phoneCode}
                    disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                    onChange={handleChange}
                  >
                    <option value="">Select phone code</option>
                    {phoneCodeList.map((phoneCode, index) => (
                      <option key={index} value={phoneCode}>
                        {`+ ${phoneCode}`}
                      </option>
                    ))}
                  </select>
                  {errors.phoneCode && <div style={{ color: 'red', fontSize: "13px" }}>{errors.phoneCode}</div>}
                </div>
                <div className="col-8">
                  <input
                    type="number"
                    className="custom-font-lt form-control"
                    id="staticEmail"
                    name="phone"
                    value={eventFormData.phone}
                    disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                    onChange={handleChange}
                    placeholder={nonEditable ? "" : "Enter a phone number"}
                  />
                  {errors.phone && <div style={{ color: 'red', fontSize: "13px" }}>{errors.phone}</div>}
                </div>
              </div>
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT CO-HOST NAME <embed />
              Optional
              <embed />
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                className="custom-font-lt form-control"
                id="staticEmail"
                name="eventCoHost"
                value={eventFormData.eventCoHost}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                placeholder={nonEditable ? "" : "Enter a name"}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT CO-HOST EMAIL <embed />
              Optional
              <embed />
            </label>
            <div className="col-sm-8 ">
              <input
                type="text"
                className="custom-font-lt form-control"
                id="staticEmail"
                name="coHostEmail"
                value={eventFormData.coHostEmail}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                placeholder={nonEditable ? "" : "Enter an email"}
                onChange={handleChange}
                onBlur={handleEmailValidation}
              />
              {errors.coHostEmail && (
                <div style={{ color: 'red', fontSize: "13px" }}>
                  {errors.coHostEmail}
                </div>
              )}
            </div>
          </div>
          {storedRole === 'Admin' && (
            <div className="form-group row mb-2">
              <label
                htmlFor="staticEmail"
                className="custom-font col-sm-4 col-form-label"
              >
                MLT EVENT
              </label>
              <div className="col-sm-3" style={{ display: 'flex', alignItems: 'flex-end' }}>
                <div className="custom-control custom-switch">
                  <span className="custom-font-slider-left">NO</span>
                  <input
                    type="hidden"
                    className="custom-control-input"
                    id="switch1"
                  />
                  <label className="switch">
                    <input
                      type="checkbox"
                      name="mltEvent"
                      onChange={handleChange}
                      checked={eventFormData.mltEvent || false}
                      disabled={eventFormData.eventStatus !== 'Draft'}
                    />
                    <span className="slider round" />
                  </label>
                  {errors.mltEvent && (
                    <div style={{ color: 'red', fontSize: '13px' }}>
                      {errors.mltEvent}
                    </div>
                  )}
                  <span className="custom-font-slider-right">YES</span>
                </div>
              </div>
            </div>
          )}

        </div>
        <div className=" bg-light rounded p-3 mt-3">
          <div className="form-group row mb-2 requestorFormDateInterval">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT DATE
            </label>
            <div className="col-sm-4">
              <div className="d-flex align-items-center">
                <input
                  type="date"
                  className="form-control-custom rounded form-control text-cursor"
                  id="staticEmail"
                  name="eventDate"
                  placeholder={nonEditable ? "" : "Pick event dates"}
                  value={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toISOString().split("T")[0]}
                  disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                  onChange={handleChange}
                />
                {errors.eventDate && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventDate}</div>}
                <span style={{ margin: '0em 1rem 0em' }}>to</span>
                <input
                  type="date"
                  className="form-control-custom rounded form-control text-cursor"
                  id="staticEmail1"
                  name="eventEndDate"
                  min={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toISOString().split("T")[0]}
                  placeholder={nonEditable ? "" : "Pick event dates"}
                  value={eventFormData.eventEndDate == '' ? '' : new Date(eventFormData.eventEndDate).toISOString().split("T")[0]}
                  disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                  onChange={handleChange}
                />
                {errors.eventEndDate && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventEndDate}</div>}
              </div>
            </div>
          </div>
          <div className="form-group row mb-2" style={{ display: 'flex', alignItems: 'baseline' }}>
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              <span>IS THE EVENT DATE FLEXIBLE</span>
            </label>
            <div className="col-sm-3" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <span className="custom-font-slider-left">NO</span>
              <div className="custom-control custom-switch">
                <input
                  type="hidden"
                  className="custom-control-input"
                  id="switch1"
                />
                <label className="switch">
                  <input type="checkbox" name="isDateFlexible"
                    onChange={handleChange}
                    checked={eventFormData.isDateFlexible || false}
                    disabled={eventFormData.eventStatus !== 'Draft'}
                  />
                  <span className="slider round" />
                </label>
                {errors.isDateFlexible && <div style={{ color: 'red', fontSize: "13px" }}>{errors.isDateFlexible}</div>}
              </div>
              <span className="custom-font-slider-right">YES</span>
            </div>
          </div>
          <div className="form-group row mb-2" style={{ display: 'flex', alignItems: 'baseline' }}>
            <div className="custom-font col-sm-4 col-form-label">
              CORPORATE CALENDAR
            </div>
            <div className="col-sm-8">
              <span onClick={() => window.open('https://calendar.mars.com', '_blank')}
                style={{ cursor: 'pointer', color: 'darkviolet', textDecorationLine: 'underline' }}>
                https://calendar.mars.com
              </span>
            </div>
          </div>
        </div>
        <div className=" bg-light rounded p-3 mt-3">
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >EXTERNAL EVENT</label>
            <div className="col-sm-8 ">
              <div className="custom-control custom-switch">
                <span className="custom-font-slider-left">NO</span>
                <input
                  type="hidden"
                  className="custom-control-input"
                  id="switch1"
                />
                <label className="switch">
                  <input type="checkbox" id="isOffSite"
                    checked={isEventOffSite}
                    onChange={handleOffSiteChange}
                    disabled={eventFormData.eventStatus !== 'Draft'}
                  />
                  <span className="slider round" />
                </label>
                <span className="custom-font-slider-right">YES</span>
              </div>
            </div>
          </div>
          {(!isEventOffSite) && (
            <>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  AFFILIATED SITE CODE
                </label>
                <div className="col-sm-8 " >
                  <select
                    className="custom-font-lt form-control form-select form-select-sm"
                    aria-label="Small select example"
                    id="staticSiteCode"
                    name="siteCode"
                    value={eventFormData.siteCode}
                    disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                    onChange={handleSiteChange}
                  >
                    <option value="">Select a sitecode</option>
                    {siteCodelist.map((siteCode, index) => (
                      <option key={index} value={siteCode}>
                        {siteCode}
                      </option>
                    ))}
                  </select>
                  {errors.siteCode && <div style={{ color: 'red', fontSize: "13px" }}>{errors.siteCode}</div>}
                </div>
              </div>
              <div className="form-group row mb-2" hidden>
                <label
                  htmlFor="staticEmail"
                  className="border-custom-strip custom-font col-sm-4 col-form-label"
                >
                  <div className=""> PLEASE SPECIFY</div>
                </label>
                <div className="col-sm-8 ">
                  <input
                    type="text"
                    className="custom-font-lt form-control"
                    id="staticEmail"
                    placeholder={nonEditable ? "" : "Type something"}
                  />
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  COUNTRY
                </label>
                <div className="col-sm-8 ">
                  <input
                    className="custom-font-lt form-control "
                    name="countryName"
                    value={eventFormData.countryName}
                    disabled={!isEventOffSite}
                    onChange={handleChange}
                  />

                  {errors.countryName && <div style={{ color: 'red', fontSize: "13px" }}>{errors.countryName}</div>}
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  REGION/CITY
                </label>
                <div className="col-sm-8 ">
                  <div className="row regionCitySpacing">
                    <div className="col-sm-6">
                      <input
                        className="custom-font-lt form-control"
                        name="stateName"
                        value={eventFormData.stateName}
                        disabled={!isEventOffSite}
                        onChange={handleChange}
                      />
                      {errors.stateName && <div style={{ color: 'red', fontSize: "13px" }}>{errors.stateName}</div>}
                    </div>
                    <div className="col-sm-6">
                      <input
                        className="custom-font-lt form-control"
                        name="cityName"
                        id="cityName"
                        value={eventFormData.cityName}
                        disabled={!isEventOffSite}
                        onChange={handleChange}
                      />
                      {errors.cityName && <div style={{ color: 'red', fontSize: "13px" }}>{errors.cityName}</div>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  EVENT VENUE NAME
                </label>
                <div className="col-sm-8 ">
                  <input
                    type="text"
                    className="custom-font-lt form-control"
                    id="eventVenueName"
                    name="eventVenueName"
                    value={eventFormData.eventVenueName}
                    disabled={!isEventOffSite}
                    onChange={handleChange}
                  />
                  {errors.eventVenueName && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventVenueName}</div>}
                </div>
              </div>
            </>
          )}
          {(!isEventOffSite) && (
            <>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  EVENT VENUE ADDRESS
                </label>
                <div className="col-sm-8 ">
                  <input
                    type="text"
                    className="custom-font-lt form-control disabled"
                    id="eventAddress"
                    name="eventAddress"
                    value={eventFormData.eventAddress}
                    disabled={true}
                  />
                  {errors.eventAddress && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventAddress}</div>}
                </div>
              </div>
            </>
          )}
          {(isEventOffSite) && (
            <>
              <div className="form-group row mb-2">
                <label
                  htmlFor="staticEmail"
                  className="custom-font col-sm-4 col-form-label"
                >
                  EXTERNAL EVENT ADDRESS
                </label>
                <div className="col-sm-8 ">
                  <textarea
                    className="custom-font-lt form-control disabled"
                    id="searchAddress"
                    name="searchAddress"
                    rows="5"
                    value={searchAddress}
                    onChange={handleSearchAddressChange}
                    disabled={eventFormData.eventStatus !== 'Draft'}
                  />
                  {errors.eventAddress && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventAddress}</div>}
                </div>
              </div>
            </>
          )}

        </div>
        <div className=" bg-light rounded p-3 mt-3">

          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT TYPE
            </label>
            <div className="col-sm-8 " >
              <select
                className="custom-font-lt form-control form-select form-select-sm"
                aria-label="Small select example"
                name="eventType"
                value={eventFormData.eventType}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
              >
                <option value="">Select a Type</option>
                {eventTypeList.map((eventType, index) => (
                  <option key={index} value={eventType}>
                    {eventType}
                  </option>
                ))}
              </select>
              {errors.eventType && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventType}</div>}
            </div>
          </div>
          {(eventFormData.eventType === "Other") && (
            <>
              <div className="form-group row mb-2" id="otherEventTypeDiv">
                <label
                  htmlFor="staticEmail"
                  className="border-custom-strip custom-font col-sm-4 col-form-label"
                >
                  <div className="" />
                  {!nonEditable ? "PLEASE SPECIFY" : "SPECIFICATION"}
                </label>
                <div className="col-sm-8  ">
                  <input
                    readOnly=""
                    type="text"
                    className="custom-font-lt form-control disabled"
                    id="staticEmail"
                    name="otherEventType"
                    value={eventFormData.otherEventType}
                    disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                    onChange={handleChange}
                  />
                  {errors.otherEventType && <div style={{ color: 'red', fontSize: "13px" }}>{errors.otherEventType}</div>}
                </div>
              </div>
            </>
          )}
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT FORMAT
            </label>
            <div className="col-sm-8 ">
              <select
                className="custom-font-lt form-control form-select form-select-sm"
                aria-label="Small select example"
                name="eventFormat"
                value={eventFormData.eventFormat}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
              >
                <option value="">Select an event type format (virtual, in-person, pre-recorded...)</option>
                {eventFormatList.map((eventFormat, index) => (
                  <option key={index} value={eventFormat}>
                    {eventFormat}
                  </option>
                ))}

              </select>
              {errors.eventFormat && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventFormat}</div>}
            </div>
          </div>
          {(eventFormData.eventFormat === "Other") && (
            <>
              <div className="form-group row mb-2" id="otherEventFormatDiv">
                <label
                  htmlFor="staticEmail"
                  className="border-custom-strip custom-font col-sm-4 col-form-label"
                >
                  <div className="" />
                  {!nonEditable ? "PLEASE SPECIFY" : "SPECIFICATION"}
                </label>
                <div className="col-sm-8  ">
                  <input
                    readOnly=""
                    type="text"
                    className="custom-font-lt form-control disabled"
                    id="staticEmail"
                    name="otherEventFormat"
                    value={eventFormData.otherEventFormat}
                    disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                    onChange={handleChange}
                  />
                  {errors.otherEventFormat && <div style={{ color: 'red', fontSize: "13px" }}>{errors.otherEventFormat}</div>}
                </div>
              </div>
            </>
          )}
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              LAST FAMILY MEMBER VISIT
            </label>
            <div className="col-sm-8 ">
              <select
                className="custom-font-lt form-control form-select form-select-sm"
                aria-label="Small select example"
                name="lastVisit"
                value={eventFormData.lastVisit}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}
              >

                <option value="">Select a Range</option>
                {lastVisitList.map((lastVisit, index) => (
                  <option key={index} value={lastVisit}>
                    {lastVisit}
                  </option>
                ))}
              </select>
              {errors.lastVisit && <div style={{ color: 'red', fontSize: "13px" }}>{errors.lastVisit}</div>}
            </div>
          </div>

        </div>
        <div className=" bg-light rounded p-3 mt-3 mb-3">

          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              ASSOCIATE(S) EXPECTED AT EVENT
            </label>

            <div className="col-sm-8">
              <div className="form-check form-check-custom rounded">
                <div className="p-3">
                  {associateAtEventChecked &&
                    associateAtEventChecked.length > 0 &&
                    associateAtEventChecked.map((associate, index) => (
                      <div key={index}>
                        <label className="form-check-label-custom form-check-label">
                          <input
                            type="checkbox"
                            value={associate.value}
                            id={associate.value}
                            className="form-check-input"
                            name="associateAtEvent"
                            checked={associate.checked}
                            onChange={toggleAssociatesCheckbox}
                            disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                          />
                          {associate.value}
                        </label>
                        <br />
                      </div>
                    ))}
                </div>
              </div>
              {/* {errors.associateAtEvent && <div style={{ color: 'red', fontSize: "13px" }}>{errors.associateAtEvent}</div>} */}
            </div>
          </div>
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              ESTIMATED TOTAL NUMBER OF ATTENDEES
            </label>
            <div className="col-sm-8 ">
              <input
                readOnly=""
                type="text"
                className="custom-font-lt form-control disabled"
                id="staticEmail"
                name="totalAttendees"
                value={eventFormData.totalAttendees}
                disabled={(eventFormData.eventStatus === 'Open event' || eventFormData.eventStatus === 'Under review') ? true : false}
                onChange={handleChange}

              />
              {errors.totalAttendees && <div style={{ color: 'red', fontSize: "13px" }}>{errors.totalAttendees}</div>}
            </div>
          </div>
          {/* dynamically create input boxes */}
          {associateAtEventChecked &&
            associateAtEventChecked.length > 0 &&
            associateAtEventChecked.map((associate, index) => {
              const apiName = associateMapping[associate.value]; // Get the API name
              if (associate.checked) {
                return (
                  <div className="form-group row mb-4" key={index}>
                    <label
                      htmlFor={`input-${index}`}
                      className="custom-font col-sm-4 col-form-label bold-label"
                    >
                      {`Estimated ${associate.value} Attendees`}
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="custom-font-lt form-control"
                        id={`inpot-${index}`}
                        name={apiName} // Set name to the API name
                        value={eventFormData[apiName] || ""} // Use the API name to access the value
                        disabled={
                          eventFormData.eventStatus === "Open event" ||
                          eventFormData.eventStatus === "Under review"
                        }
                        onChange={handleChange}
                        placeholder={nonEditable ? "" : "Type an estimation"}
                      />
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </div>
      <div className="col-md-4 rounded" id="MapID">
        {/* <MapComponent/> */}

      </div>
      <div style={{ height: "100px" }}></div>
    </>
  );

  return content
}
export default EventMlt